import { graphql, HeadProps, PageProps } from 'gatsby';
import React from 'react';
import { HeroComponentRenderer } from '../components/componentRenderer/HeroComponentRenderer';
import { PageComponentRenderer } from '../components/componentRenderer/PageComponentRenderer';
import { SEO } from '../components/Seo';
import { Breadcrumb } from '../components/breadcrumb/Breadcrumb';
import { useGlobalSettings } from '../hooks/useGlobalSettings';

const Page = ({ data }: PageProps<Queries.UmbracoPageQuery>) => {
  const properties = data.page?.properties;

  const pageComponents = properties?.pageComponents;
  const heroComponents = properties?.heroComponents;
  const pageComponentsData = pageComponents?.[0]?.block?.components;
  const heroComponentsData = heroComponents?.[0]?.block?.components;

  return (
    <>
      <Breadcrumb page={data.page} />
      <HeroComponentRenderer components={heroComponentsData} />
      <PageComponentRenderer components={pageComponentsData} />
    </>
  );
};

export default Page;

export const Head = ({ data }: HeadProps<Queries.UmbracoPageQuery>) => {
  const {
    siteMeta: { siteUrl },
  } = useGlobalSettings();
  const seo = data.page?.properties?.seo;
  const feedImg =
    data.page?.properties?.feed?.featuredImage?.image?.localFile?.ogImg?.src;
  const heroImg = data?.page?.properties?.heroComponents[0]?.block
    ?.components?.[0]?.image?.image
    ? data.page.properties.heroComponents[0].block.components[0].image.image
        .localFile?.ogImg?.src
    : undefined;
  const schema = data.page?.properties?.schema;
  const properties = data.page?.properties;
  const pageComponents = properties?.pageComponents;
  const pageComponentsData = pageComponents?.[0]?.block?.components;
  const hasFeefoSchemaComponent = pageComponentsData?.some(
    (item) => item?.remoteTypeName === 'FeefoSchemaComponentType'
  );

  const productSchema = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: 'Public liability insurance',
    description:
      'Protect your limited company or self-employed business and buy peace of mind with our public liability insurance cover. Get a quote and cover online in 5 mins.',
    brand: {
      '@type': 'Brand',
      '@id': 'Trade_Direct_Insurance',
    },

    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: 4.8,
      bestRating: 5,
      reviewCount: 2118,
    },
  };

  return (
    <>
      return{' '}
      <SEO
        data={seo}
        image={`${siteUrl}${feedImg || heroImg || undefined}`}
        canonical={`${siteUrl}${data?.page?.url}`}
      />
      ;
      {hasFeefoSchemaComponent && (
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      )}
      {schema?.schemaField && (
        <script type="application/ld+json">{schema?.schemaField}</script>
      )}
    </>
  );
};

export const umbracoPageQuery = graphql`
  query UmbracoPage($id: String!) {
    page: umbracoPageType(id: { eq: $id }) {
      name
      url
      remoteId
      parentPages {
        url
        name
      }
      ... on UMBRACO_PageType {
        properties {
          ...PageComponents
          ...HeroComponents
          seo {
            ...SEO
          }
          schema {
            schemaField
          }
          feed {
            featuredImage {
              image {
                ...PageListingImage
              }
            }
          }
        }
      }
    }
  }
`;
